import React, { useState } from 'react'
import '../profileTabs/ProfileTab.css'

const ProfileTab = () => {
    const [selectedSugarType, setSelectedSugarType] = useState("Sugar Daddy");
    const [selectedSex, setSelectedSex] = useState("Male");
    const [selectedSexuality, setSelectedSexuality] = useState("Straight");
  return (
    <div className='tabs-detail-sec profile-tab'>
        <form action="">
            <div className='profile-box'>
                <div className='profile-account d-flex flex-wrap align-items-center justify-content-between'>
                    <h3>Private account</h3>
                    <div className='toggle-radio'>
                        <label className="switch">
                        <input type="checkbox"  />
                        <span className="slider round"></span>
                        </label>
                    </div>
                </div>
                <div className='profile-content-details'>
                    <div className='form-group'>
                        <input type="text" className="form-control" id="" placeholder="Username" />
                    </div>
                    <div className='form-group'>
                        <input type="text" className="form-control" id="" placeholder="Name" />
                    </div>
                    <div className="form-group d-flex flex-wrap align-items-center">
                        <label for="" className="col-form-label ">Description </label>
                        <div className="form-box">
                            <textarea name="" rows="5" cols="40" id="" placeholder=''></textarea>
                        </div>
                    </div>
                    <div className='form-group'>
                        <input type="text" className="form-control" id="" placeholder="Default Address..." />
                    </div>
                    <div className='filter-box mb-md-4 mb-3'>
                        <ul className='radio-box-checked'>
                            <li>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="sugarType" id="sugarDaddy" value="Sugar Daddy" checked={selectedSugarType==="Sugar Daddy" } onChange={()=> setSelectedSugarType("Sugar Daddy")} />
                                    <label className="form-check-label" htmlFor="sugarDaddy">Sugar Daddy</label>
                                </div>
                            </li>
                            <li>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="sugarType" id="sugarMummy" value="Sugar Mummy" checked={selectedSugarType==="Sugar Mummy" } onChange={()=> setSelectedSugarType("Sugar Mummy")} />
                                    <label className="form-check-label" htmlFor="sugarMummy">Sugar Mummy</label>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className='filter-box mb-md-4 mb-3'>
                        <h3>Sex</h3>
                        <ul className='radio-box-checked'>
                            <li>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="sex" id="female" value="Female" checked={selectedSex==="Female" } onChange={()=> setSelectedSex("Female")} />
                                    <label className="form-check-label" htmlFor="female">Female</label>
                                </div>
                            </li>
                            <li>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="sex" id="male" value="Male" checked={selectedSex==="Male" } onChange={()=> setSelectedSex("Male")} />
                                    <label className="form-check-label" htmlFor="male">Male</label>
                                </div>
                            </li>
                            <li>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="sex" id="transMale" value="Trans-Male" checked={selectedSex==="Trans-Male" } onChange={()=> setSelectedSex("Trans-Male")} />
                                    <label className="form-check-label" htmlFor="transMale">Trans-Male</label>
                                </div>
                            </li>
                            <li>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="sex" id="transFemale" value="Trans-Female" checked={selectedSex==="Trans-Female" } onChange={()=> setSelectedSex("Trans-Female")} />
                                    <label className="form-check-label" htmlFor="transFemale">Trans-Female</label>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className='filter-box mb-md-4 mb-3'>
                        <h3>Sexuality</h3>
                        <ul className='radio-box-checked'>
                            <li>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="sexuality" id="straight" value="Straight" checked={selectedSexuality==="Straight" } onChange={()=> setSelectedSexuality("Straight")} />
                                    <label className="form-check-label" htmlFor="straight">Straight</label>
                                </div>
                            </li>
                            <li>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="sexuality" id="gay" value="Gay" checked={selectedSexuality==="Gay" } onChange={()=> setSelectedSexuality("Gay")} />
                                    <label className="form-check-label" htmlFor="gay">Gay</label>
                                </div>
                            </li>
                            <li>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="sexuality" id="biSexual" value="Bi-Sexual" checked={selectedSexuality==="Bi-Sexual" } onChange={()=> setSelectedSexuality("Bi-Sexual")} />
                                    <label className="form-check-label" htmlFor="biSexual">Bi-Sexual</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </form>
    </div>
  )
}

export default ProfileTab
